<template>
  <div id="app">
    <router-view ref="layout" />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
